import Article from '@/components/Article';
import Button from '@/components/_common/Button';
import GradientWrapper from '@/components/_common/GradientWrapper';
import { Helmet } from 'react-helmet-async';
import StaticPageLayout from '@/layouts/StaticPageLayout';
import { appDataContext } from '@/context';
import { useContext } from 'react';
import { useLangStore } from '@/store/lang-store';

const Contact = () => {
  const context = useContext(appDataContext);
  const { langStore } = useLangStore();
  const properties = context.properties;
  const text = context.lang;

  return (
    <>
      <Helmet>
        <title>{` ${text?.contact.title} - ${text?.site.title}`}</title>
      </Helmet>

      <StaticPageLayout>
        <header>
          <h1>{text?.contact.title}</h1>
        </header>

        <GradientWrapper $padding='3rem 2rem' $margin='16px 0'>
          <h2>{text?.contact.contactus}</h2>
          <Button
            as='a'
            $small
            color='green'
            className='button success'
            onClick={(e) => {
              window.location.href = 'mailto:support@mazout.com';
              e.preventDefault();
            }}>
            {text?.contact.title}
          </Button>
        </GradientWrapper>

        <Article
          className='article'
          lang={langStore}
          url={properties?.contact.articles.url2}
          hideImage={true}
          hideTitle={true}
        />
      </StaticPageLayout>
    </>
  );
};

export default Contact;
